import React                 from 'react';
import { arrayY as tooltip } from 'pu-data/Tooltips';
import TextComponent         from './TextComponent';

const ArrayY = (props) => {
  const name = 'array_y';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  const { parameters } = props
  return (
    <TextComponent
      label="Array Overall Width (inches)"
      name={name}
      value={parameters[name] || ''}
      onChange={props.onChange || onChange}
      tooltip={tooltip}
      groupName={props.groupName} />
  );
};

ArrayY.defaultProps = {};

export default ArrayY;
